import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// Login
const Login = () => import('../views/Login.vue')
const LoginForm = () => import('../views/login/LoginForm.vue')
const RegisterForm = () => import('../views/login/RegisterForm.vue')
const ForgetForm = () => import('../views/login/ForgetForm.vue')

// main
const Main = () => import('../views/Main.vue')
const Product = () => import('../views/main/Product.vue')
const Device = () => import('../views/main/Device.vue')
const UserInfo = () => import('../views/main/UserInfo.vue')
const Manager = () => import('../views/manager/Manager.vue')

// device
const ProductInfo = () => import('../views/main/device/ProductInfo.vue')
const DataPoint = () => import('../views/main/device/DataPoint.vue')
const ModbusPoint = () => import('../views/main/device/ModbusPoint.vue')
const DeviceList = () => import('../views/main/device/DeviceList.vue')
const DeviceData = () => import('../views/main/device/DeviceData.vue')
const DeviceLine = () => import('../views/main/device/DeviceLine.vue')

// manager
const ManagerDevice = () => import('../views/manager/ManagerDevice.vue')

const routes = [
  {
    path: '/',
    redirect: '/login/loginForm'
  },
  {
    path: '/login',
    component: Login,
    children: [
      {
        path: '/login/loginForm',
        component: LoginForm
      },
      {
        path: '/login/registerForm',
        component: RegisterForm
      },
      {
        path: '/login/forgetForm',
        component: ForgetForm
      }
    ]
  },
  {
    path: '/main',
    component: Main,
    children: [
      {
        path: '/main/product',
        component: Product
      },
      {
        path: '/main/device',
        name: 'device',
        component: Device,
        children: [
          {
            path: '/main/device/productInfo',
            name: 'productInfo',
            component: ProductInfo
          },
          {
            path: '/main/device/dataPoint',
            name: 'dataPoint',
            component: DataPoint
          },
          {
            path: '/main/device/modbusPoint',
            name: 'modbusPoint',
            component: ModbusPoint
          },
          {
            path: '/main/device/deviceList',
            name: 'deviceList',
            component: DeviceList
          },
          {
            path: '/main/device/deviceData',
            name: 'deviceData',
            component: DeviceData
          },
          {
            path: '/main/device/deviceLine',
            name: 'deviceLine',
            component: DeviceLine
          }
        ]
      },
      {
        path: '/main/userInfo',
        name: 'userInfo',
        component: UserInfo
      },
      {
        path: '/main/manager',
        name: 'manager',
        component: Manager,
        children: [
          {
            path: '/main/manager/managerDevice',
            name: 'managerDevice',
            component: ManagerDevice
          }
        ]
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
  console.log(to.path)
  if (to.path.indexOf('/login/') >= 0) {
    next()
  } else {
    if (localStorage.getItem('Token')) {
      next()
    } else {
      next('/login/loginForm')
    }
  }
})

export default router
